/*
 * This files contains styles
 * that are not in component scope.
 */
export default {
    '.category-title-plp .content-asset h2': {
        fontSize: '28px',
        textAlign: 'center',
        margin: '0 0 16px 0',
        fontWeight: '700'
    },
    '.category-title-plp .content-asset h2 p': {
        fontSize: '16px',
        fontWeight: '500'
    },
    '.productlists-main-block': {
        '.product-block': {
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: ['8px', '10px 10px 0', '15px 15px 0'],
            flex: '1 1 auto',
            maxWidth: 'calc(50% - 10px)'
        },

        '&.filter-hidden': {
            '.product-block': {
                maxWidth: {
                    base: 'calc(100% - 10px)',
                    sm: 'calc(33.333% - 12px)',
                    md: 'calc(32% - 14px)',
                    xl: 'calc(24.3% - 16px)'
                },
                width: {
                    base: 'calc(100% - 10px)',
                    sm: 'calc(33.333% - 12px)',
                    md: 'calc(32% - 14px)',
                    xl: 'calc(24.3% - 16px)'
                }
            }
        },

        '&.filter-active': {
            '.product-block': {
                maxWidth: {base: '100%', sm: 'calc(50% - 12px)', md: 'calc(32% - 14px)', xl: '31%'},
                width: {base: '100%', sm: 'calc(50% - 12px)', md: 'calc(32% - 14px)', xl: '31%'}
            }
        }
    },

    '@media (min-width: 768px) and (max-width: 1023px)': {
        '.productlists-main-block': {
            '.product-block': {
                maxWidth: 'calc(33.333% - 15px)'
            }
        }
    },
    '@media (max-width: 767px)': {
        '.productlists-main-block': {
            '.product-block': {
                width: '100%'
            }
        }
    },
    '.sort-box .chakra-select__icon-wrapper': {
        width: '40px',
        display: 'none'
    },

    '.sort-box .chakra-select__icon': {
        width: '34px !important',
        height: '34px !important'
    },
    '.sort-box select': {
        padding: '14px 50px'
    },
    '.mobileChanges .sort-box select': {
        padding: '14px 35px',
        border: 'none',
        fontWeight: 'extrabold',
        lineHeight: 5,
        cursor: 'pointer',
        backgroundRepeat: 'no-repeat',
        height: 'auto',
        backgroundPosition: 'center right 16px',
        backgroundSize: '20px 20px'
    },
    '.checkbox-block input, .custom-control.wishlist-hide input': {
        position: 'absolute',
        height: '0',
        width: '0'
    },
    '.custom-check-box .chakra-checkbox__control': {
        background: 'white ',
        border: '3px solid #f47521',
        borderRadius: '4px',
        color: '#ff640a',
        margin: '0',
        width: '20px',
        height: '20px',
        svg: {
            stroke: '#ffffff !important',
            width: '14px',
            height: '12px'
        }
    },
    '.chakra-checkbox__label': {
        marginLeft: '12px',
        fontSize: 'md'
    },
    '.custom-check-box input:checked + span.chakra-checkbox__control': {
        backgroundColor: '#f47521',
        border: '2px solid #f47521',
        outline: 'none'
    },
    '.custom-check-box input:focus-visible ~ .chakra-checkbox__control': {
        outline: '2px dotted'
    },
    '.chakra-checkbox__control:after': {
        content: '""',
        position: 'absolute',
        display: 'none'
    },
    '.checkbox-block.wishlist-item-checkbox .chakra-checkbox__control:after': {
        display: 'block'
    },
    '.custom-check-box .chakra-checkbox__control:after, .custom-check-box.wishlist-item-checkbox .chakra-checkbox__control:after':
        {
            left: '4px',
            top: '0px',
            width: '5px',
            height: '10px',
            border: 'solid white',
            borderWidth: '0 3px 3px 0',
            WebkitTransform: 'rotate(45deg)',
            msTransform: 'rotate(45deg)',
            transform: 'rotate(45deg)'
        }
}
